import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../../servicios/user.service'

@Component({
  selector: 'app-navbar-admin',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarAdminComponent implements OnInit {

  public userService: UserService;

  constructor( _userService: UserService ) { this.userService = _userService; }

  ngOnInit() {
  }


  
  Logout() {
    
    localStorage.removeItem('userToken');
    localStorage.removeItem('userName');
    localStorage.removeItem('userRoles');
    localStorage.clear();
    
    window.location.href = "/";
    
  }

}
